module.exports = __webpack_public_path__ + "img/product_12.289e5d2.svg";